import React from 'react'
import icon1 from '../../assets/img/Message.svg';
import icon2 from '../../assets/img/Lock.svg';
import icon3 from '../../assets/img/Profile.svg';
import icon4 from '../../assets/img/Call.svg';
// import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import { Form, Button } from 'react-bootstrap';
import './Signup.css';





const Signup = () => {
  return (
    <section className="accounts_section">
    <Container>
        <div className="accounts_card_main_div">
            <div className="accounts_title">
                <h2>Sign Up</h2>
                <p>Let’s create new account</p>
            </div>
            <Form className="accounts_input_main">
            <div className="accounts_input_div">
                    <input type="text" placeholder='First name' />
                    <img src={icon3} alt="" />
                </div>
                <div className="accounts_input_div">
                    <input type="text" placeholder='Last name' />
                    <img src={icon3} alt="" />
                </div>
                <div className="accounts_input_div">
                    <input type="email" placeholder='Email' />
                    <img src={icon1} alt="" />
                </div>
                <div className="accounts_input_div">
                    <input type="number" placeholder='Phone number' />
                    <img src={icon4} alt="" />
                </div>
                <div className="accounts_input_div">
                    <input type="password" placeholder='Password' />
                    <img src={icon2} alt="" />
                </div>
            </Form>
            <div className="terms_text">
                <input type="checkbox" id='terms' />
                <label htmlFor="terms">By creating an account, you are acknowledging and accepting the terms and conditions, thereby entering into a legally binding contract with the service provider.</label>
            </div>
            <div className="accounts_btn">
                <Button>Agree and continue</Button>
            </div>
        </div>
    </Container>
</section>
  )
}

export default Signup